import { render, staticRenderFns } from "./en_header.vue?vue&type=template&id=851050a8&scoped=true"
import script from "./en_header.vue?vue&type=script&lang=js"
export * from "./en_header.vue?vue&type=script&lang=js"
import style0 from "./en_header.vue?vue&type=style&index=0&id=851050a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851050a8",
  null
  
)

export default component.exports